import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, List, Unstable_Grid2 as Grid } from '@mui/material';
import { darken } from '@mui/material/styles';

import { Network } from 'api';
import { ConnectAccount, Connection, SocialIcon } from 'components';
import { useNetworkCapabilities, useSocialConnections } from 'hooks';
import { connectionPopup } from 'helpers';
import theme from 'theme';

const styles = {
  button: {
    color: 'common.white',
    '&:hover': {
      color: 'common.white',
    },
  },
  twitter: {
    backgroundColor: theme.custom.networks.x,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.x, 0.1),
    },
  },
  linkedin: {
    backgroundColor: theme.custom.networks.linkedin,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.linkedin, 0.1),
    },
  },
} as const;

const SetupSocials: FC = () => {
  const { t } = useTranslation();
  const { hasTwitter } = useNetworkCapabilities();
  const { connections } = useSocialConnections();

  return (
    <Fragment>
      {!!connections.length && (
        <Box marginTop={3}>
          <List>
            {connections.map(account => (
              <Connection key={account.id} account={account} />
            ))}
          </List>
        </Box>
      )}
      <Box marginTop={3}>
        <Grid container spacing={1}>
          <ConnectAccount network={Network.Linkedin}>
            <Grid>
              <Button
                fullWidth
                variant="contained"
                sx={{ ...styles.button, ...styles.linkedin }}
                onClick={() => connectionPopup(Network.Linkedin)}
                startIcon={<SocialIcon state="inverted" provider="linkedin" />}
              >
                {t('user:connectToLinkedIn')}
              </Button>
            </Grid>
          </ConnectAccount>
          {hasTwitter && (
            <ConnectAccount network={Network.Twitter}>
              <Grid>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ ...styles.button, ...styles.twitter }}
                  onClick={() => connectionPopup(Network.Twitter)}
                  startIcon={<SocialIcon state="inverted" provider="twitter" />}
                >
                  {t('user:connectToX')}
                </Button>
              </Grid>
            </ConnectAccount>
          )}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default SetupSocials;
